import Vue from 'vue'
import Vuex from 'vuex'
import store from './store'
import './config/rem'
import App from './App.vue'
Vue.config.productionTip = false
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueRouter from 'vue-router'
Vue.prototype.$axios = axios
axios.defaults.baseURL = '/api'

import { download } from './utils/download'
Vue.prototype.download = download

// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
// axios.defaults.headers.post['Content-Type'] = 'application/json';
Vue.directive('title', {
  inserted: function (el) {
    document.title = el.dataset.title
  }
})

Vue.use(VueAxios, axios,VueRouter)
new Vue({
  store,
  render: h => h(App),
}).$mount('#app')
